export default __webpack_public_path__ + "static/media/Calendar.aff8edaa.svg";